import { useEffect } from 'react';

const RobotsTxt = () => {
  useEffect(() => {
    // Fetch and display the robots.txt content
    fetch('/robots.txt')
      .then(response => response.text())
      .then(text => {
        // Set content type and display as plain text
        document.body.innerHTML = `<pre style="font-family: monospace; white-space: pre-wrap;">${text}</pre>`;
      })
      .catch(() => {
        document.body.innerHTML = 'robots.txt not found';
      });
  }, []);

  return null;
};

export default RobotsTxt;
